var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.49464 0.556355C0.337826 0.713068 0.213429 0.899145 0.128557 1.10395C0.0436844 1.30876 1.83755e-07 1.52828 1.81111e-07 1.74998C1.78467e-07 1.97168 0.0436844 2.1912 0.128557 2.39601C0.213429 2.60082 0.337826 2.78689 0.49464 2.94361L5.65277 8.10286C5.75822 8.20834 5.81746 8.35139 5.81746 8.50054C5.81746 8.6497 5.75822 8.79275 5.65277 8.89823L0.49464 14.0564C0.178071 14.3728 0.00016452 14.802 5.90287e-05 15.2496C-4.64625e-05 15.6972 0.177657 16.1265 0.494077 16.443C0.810497 16.7596 1.23971 16.9375 1.6873 16.9376C2.1349 16.9377 2.5642 16.76 2.88077 16.4436L8.04002 11.2844C8.40569 10.9187 8.69576 10.4846 8.89366 10.0069C9.09156 9.52914 9.19343 9.01709 9.19343 8.49998C9.19343 7.98287 9.09156 7.47082 8.89366 6.99307C8.69576 6.51533 8.40569 6.08124 8.04002 5.7156L2.88077 0.556355C2.56431 0.239998 2.13517 0.0622788 1.6877 0.0622788C1.24024 0.0622788 0.811093 0.239998 0.49464 0.556355Z",
    fill: "#8A8A8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.a3fcebd703c839c264fe596203ae0eb7.svg";
export { ForwardRef as ReactComponent };